import { jsxs as l, jsx as e, Fragment as m } from "react/jsx-runtime";
import a from "react";
import { AnimatePresence as p, motion as s } from "framer-motion";
import { cn as c } from "../../../lib/utils.js";
const d = a.createContext({ open: !1, onOpenChange: () => {
} });
function y({ open: t, onOpenChange: n, children: i, className: r }) {
  return l(d.Provider, { value: { open: t, onOpenChange: n }, children: [e("div", { className: c(r), children: i }), e(p, { children: t && l(m, { children: [e(s.div, { className: "fixed inset-0 z-50 bg-black/40 backdrop-blur-sm", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, onClick: () => n(!1) }), e("div", { className: "pointer-events-none fixed inset-0 z-50 flex items-center justify-center p-4", children: a.Children.map(i, (o) => a.isValidElement(o) && o.props.__modalContent ? o : null) })] }) })] });
}
function C({ children: t, className: n }) {
  const { onOpenChange: i } = a.useContext(d);
  return e("button", { type: "button", className: c(n), onClick: () => i(!0), children: t });
}
function u({ children: t, className: n }) {
  const { open: i, onOpenChange: r } = a.useContext(d);
  return e(p, { children: i && l(m, { children: [e(s.div, { className: "fixed inset-0 z-50 bg-black/40 backdrop-blur-sm", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, onClick: () => r(!1) }), e("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4", children: e(s.div, { className: c("pointer-events-auto relative w-full max-w-lg rounded-2xl bg-[var(--bg-surface)] border-2 border-[var(--border-color)] p-6 shadow-2xl", n), style: { perspective: 1200 }, initial: {
    opacity: 0,
    scale: 0.9,
    rotateX: 12
  }, animate: {
    opacity: 1,
    scale: 1,
    rotateX: 0
  }, exit: {
    opacity: 0,
    scale: 0.92
  }, transition: {
    type: "spring",
    stiffness: 350,
    damping: 28
  }, children: t }) })] }) });
}
u.defaultProps = { __modalContent: !0 };
export {
  y as AnimatedModal,
  u as AnimatedModalContent,
  C as AnimatedModalTrigger
};
//# sourceMappingURL=AnimatedModal.js.map
